export default [
	{value: 'normal', name: 'bar'},
	{value: 'milestone', name: 'milestone', classes: 'fa-stop fa-rotate-45'},
	{value: 'flag', name: 'flag', classes: 'fa-flag'},
	{value: 'smiley', name: 'smiley', classes: 'fa-smile-o'},
	{value: 'warning', name: 'warning', classes: 'fa-exclamation-triangle'}
];
